module.exports = __webpack_public_path__ + "img/hellenb1.36297e67.jpg";